<template>
  <div class="fixed top-0 left-0 right-0 bottom-0 flex bg-white">
    <!-- <div class="text-sm px-6 md:text-base leading-tight border-b border-black fixed top-0 left-0 right-0 py-2 bg-white text-center bg-white z-10">Cosmopolis is a platform for research-based and collaborative art practices.</div> -->
    <div class="hidden md:flex flex-col w-1/2 mb-12">
      <a
        href="https://c1.cosmopolis.woo.cat"
        class="hover-toggle border-black border-b h-half flex items-center justify-center relative"
      >
        <span
          class="hover-show text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-12 w-full tracking-wide"
        >18.10 – 18.12.17</span>
        <span class="flex items-center">
          <BaseHash class="mr-6 mt-8" style="height: 5vw; margin-bottom: 0.5vw" />
          <span class="text-huge">1</span>
        </span>
        <span
          class="hover-show text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-12 w-full tracking-wide"
        >Centre Pompidou, Paris, France</span>
      </a>
      <a
        href="http://www.cosmopolischengdu.com/en/"
        class="hover-toggle h-half flex items-center justify-center relative"
      >
        <span
          class="hover-show text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-12 w-full tracking-wide"
        >03.11.18 – 06.01.19</span>
        <span class="flex items-center flex-col">
          <div class="flex items-center">
            <BaseHash class="inline mr-6 mt-8" style="height: 5vw; margin-bottom: 0.5vw" />
            <span class="text-huge">1.5</span>
          </div>
        </span>
        <span
          class="hover-show text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-12 w-full tracking-wide"
        >Chengdu, China</span>
      </a>
    </div>
    <router-link
      to="/home"
      class="hidden md:flex hover-toggle w-1/2 mb-12 items-center justify-center border-black border-l relative"
    >
      <span
        class="hover-show text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-12 w-full tracking-wide"
      >23.10 - 23.12.19</span>
      <span class="flex items-center relative">
        <BaseHash class="mr-6 mt-8" style="height: 5vw; margin-bottom: 0.5vw" />
        <span class="text-huge" style="font-size: 32vw">2</span>
      </span>
      <span
        class="hover-show text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-12 w-full tracking-wide"
      >Centre Pompidou, Paris, France</span>
    </router-link>

    <!-- MOBILE -->
    <div class="flex md:hidden flex-col w-full">
      <router-link
        to="/home"
        class="cosmo-block w-full flex items-center justify-center border-black border-b relative"
      >
        <span
          class="text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-6 w-full tracking-wide"
        >23.10 - 23.12.19</span>
        <span class="flex items-center relative">
          <BaseHash class="mr-2 mt-1" style="height: 5vw; margin-bottom: 0.5vw" />
          <span class="text-huge">2</span>
        </span>
        <span
          class="text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-6 w-full tracking-wide"
        >Centre Pompidou, Paris, France</span>
      </router-link>
      <a
        href="http://www.cosmopolischengdu.com/en/"
        class="cosmo-block border-black border-b flex items-center justify-center relative"
      >
        <span
          class="text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-6 w-full tracking-wide"
        >03.11.18 – 06.01.19</span>
        <span class="flex items-center flex-col">
          <div class="flex items-center">
            <BaseHash class="inline mr-2 mt-1" style="height: 5vw; margin-bottom: 0.5vw" />
            <span class="text-huge">1.5</span>
          </div>
        </span>
        <span
          class="text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-6 w-full tracking-wide"
        >Chengdu, China</span>
      </a>
      <a
        href="http://cosmopolis.centrepompidou.fr"
        class="cosmo-block flex items-center justify-center relative"
      >
        <span
          class="text-sm md:text-base px-6 leading-tight absolute top-0 left-0 text-center mt-6 w-full tracking-wide"
        >18.10 – 18.12.17</span>
        <span class="flex items-center">
          <BaseHash class="mr-2 mt-1" style="height: 5vw; margin-bottom: 0.5vw" />
          <span class="text-huge">1</span>
        </span>
        <span
          class="text-sm md:text-base px-6 leading-tight absolute bottom-0 left-0 text-center mb-6 w-full tracking-wide"
        >Centre Pompidou, Paris, France</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "landing"
}
</script>

<style lang="stylus" scoped>
.cosmo-block {
  height: calc(33vh - 1rem);
}

.now {
  width: 5vw;
  height: 5vw;
  font-size: 1.2vw;
  right: -3.5em;
  top: 6.5em;
}

.now-mobile {
  width: 10vw;
  height: 10vw;
  font-size: 3vw;
  right: 2em;
  top: 2em;
}

.hover-toggle:hover .hover-show {
  @apply: tracking-widest;
}
</style>
